/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { skillEfficacyUpsertSettings } from "../funcs/skillEfficacyUpsertSettings.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { SkillEfficacySettings } from "../models/components/skillefficacysettings.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpsertSkillEfficacySettingsRequest,
  UpsertSkillEfficacySettingsSecurity,
} from "../models/operations/upsertskillefficacysettings.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpsertSkillEfficacySettingsMutationVariables = {
  request: UpsertSkillEfficacySettingsRequest;
  security?: UpsertSkillEfficacySettingsSecurity | undefined;
  options?: RequestOptions;
};

export type UpsertSkillEfficacySettingsMutationData = SkillEfficacySettings;

export type UpsertSkillEfficacySettingsMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * upsertSettings skillEfficacy
 *
 * @remarks
 * Create or replace organization-wide skill efficacy sampling settings.
 */
export function useUpsertSkillEfficacySettingsMutation(
  options?: MutationHookOptions<
    UpsertSkillEfficacySettingsMutationData,
    UpsertSkillEfficacySettingsMutationError,
    UpsertSkillEfficacySettingsMutationVariables
  >,
): UseMutationResult<
  UpsertSkillEfficacySettingsMutationData,
  UpsertSkillEfficacySettingsMutationError,
  UpsertSkillEfficacySettingsMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpsertSkillEfficacySettingsMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpsertSkillEfficacySettings(): MutationKey {
  return ["@gram/client", "skillEfficacy", "upsertSettings"];
}

export function buildUpsertSkillEfficacySettingsMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpsertSkillEfficacySettingsMutationVariables,
  ) => Promise<UpsertSkillEfficacySettingsMutationData>;
} {
  return {
    mutationKey: mutationKeyUpsertSkillEfficacySettings(),
    mutationFn: function upsertSkillEfficacySettingsMutationFn({
      request,
      security,
      options,
    }): Promise<UpsertSkillEfficacySettingsMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(skillEfficacyUpsertSettings(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
